import script from "./ProductModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductModal.vue?vue&type=script&setup=true&lang=ts"

import "./ProductModal.vue?vue&type=style&index=0&id=5d5ff8c5&lang=scss&scoped=true"

import exportComponent from "/var/www/zioncallmanagement.com/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d5ff8c5"]])

export default __exports__